export interface GetAllDashboardsResult {
  dashboards: Dashboard[];
}

export interface AddDashboardResult {
  dashboard: Dashboard;
}

export interface DuplicateDashboardRequest {
  id: string;
  nameUserInput: string;
}

export interface DuplicateDashboardResult {
  dashboard: Dashboard;
}

export interface GetDashboardResult {
  dashboard: Dashboard;
}

export interface CopyDashboardRequest {
  dashboardId: string;
  fromCompanyCode: string;
  toCompanyCode: string;
  newDashboardNameUserInput: string;
  copyConditionValues: boolean;
  tileIds: string[];
}

export interface CopyDashboardResult {
  originalDashboardId: string;
  newDashboardId: string;
  success: boolean;
  errorMessage: string;
  tileCopyResults: TileCopyResult[];
}

export interface TileCopyResult {
  tileId: string;
  originalReportId: string | null;
  newReportId: string | null;
  hasRequiredDataset: boolean;
  requiredDataSetName: string;
  success: boolean;
  errorMessage: string;
}

export interface Dashboard {
  dashboardId: string;
  nameUserInput: string;
  clientCode: string;
  createdBy: string;
  modifiedBy: string;
  modifiedAt: string;
  tiles: Tile[];
  isDraft: boolean;
}

export interface TileSmartView {
  tileId: string;
  location: TileLocation;
  widget: SmartViewWidget;
  breakpoint?: CanvasBreakpoints;
}

export interface TileFilter {
  tileId: string;
  location: TileLocation;
  widget: FilterWidget;
  breakpoint?: CanvasBreakpoints;
}

export type Tile = TileSmartView | TileFilter;

export type Widget = {
  widgetId: string;
  dashboardId: string;
  tileId: string;
  clientCode: string;
  nameUserInput: string;
  type: WidgetType;
  createdBy: string;
  emailCreatedBy: string;
  modifiedBy: string;
  emailModifiedBy: string;
  etag: string;
  hideTitle?: boolean;
};

export type SmartViewWidget = Widget & {
  type: WidgetType.SmartView;
  reportId: string;
  isDraft?: boolean;
};

export type FilterWidget = Widget &
  FilterWidgetSettings & {
    type: WidgetType.Filter;
    dashboardFilterId?: string;
    isDraft?: boolean;
  };

export type FilterWidgetSettings = {
  componentType: FilterComponentType;
  singleSelect: boolean;
  defaultValue: unknown[];
  referenceDate?: ReferenceDateType;
  hideTitle?: boolean;
  parentWidgetId?: string | null;
  hideSecondaryColumn?: boolean;
};

export enum FilterComponentType {
  Dropdown = "Dropdown",
  List = "List",
  Tile = "Tile",
}

export type Widgets = SmartViewWidget | FilterWidget;

export enum WidgetType {
  SmartView = "SmartView",
  Filter = "Filter",
}

export interface TileLocation {
  row: number;
  column: number;
  width: number;
  height: number;
  minWidth?: number;
  minHeight?: number;
  maxWidth?: number;
  maxHeight?: number;
  isStatic?: boolean;
  isDraggable?: boolean;
  isResizable?: boolean;
}

export type CanvasBreakpoints = "lg" | "md" | "sm" | "xs" | "xxs";

export enum ReferenceDateType {
  ThisMonth = "ThisMonth",
  ThisQuarter = "ThisQuarter",
  ThisYear = "ThisYear",
  LastMonth = "LastMonth",
  LastQuarter = "LastQuarter",
  LastYear = "LastYear",
  Last7Days = "Last7Days",
  Last30Days = "Last30Days",
  Last12Months = "Last12Months",
  CustomRange = "CustomRange",
}
